import {createContext} from "react";
import {Report} from "../types/Report";

const ReportContext = createContext({
    report: undefined as Report | undefined
});

export default ReportContext;
